const SYNODIC = 29.530588853;
const KNOWN_NEW = Date.UTC(2000, 0, 6, 18, 14, 0);

export function startOfLocalDay(date: Date): Date {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

export function toIsoDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function lunarAgeDays(date: Date): number {
  const days = (date.getTime() - KNOWN_NEW) / 86_400_000;
  return ((days % SYNODIC) + SYNODIC) % SYNODIC;
}

/** 0 = new moon, 1 = full moon. */
export function moonIllumination(date: Date): number {
  const phase = (2 * Math.PI * lunarAgeDays(date)) / SYNODIC;
  return (1 - Math.cos(phase)) / 2;
}

export function phaseName(illumination: number, ageDays: number): string {
  if (illumination < 0.03) return "New moon";
  if (illumination < 0.35) {
    return ageDays < SYNODIC / 2 ? "Waxing crescent" : "Waning crescent";
  }
  if (illumination < 0.6) {
    return ageDays < SYNODIC / 2 ? "First quarter" : "Last quarter";
  }
  if (illumination < 0.97) {
    return ageDays < SYNODIC / 2 ? "Waxing gibbous" : "Waning gibbous";
  }
  return "Full moon";
}

export function moonQuality(
  illumination: number,
): "dark" | "fair" | "bright" {
  if (illumination <= 0.18) return "dark";
  if (illumination <= 0.4) return "fair";
  return "bright";
}

export function nextNewMoon(from: Date): Date {
  const age = lunarAgeDays(from);
  const remaining = (SYNODIC - age) % SYNODIC;
  return new Date(from.getTime() + remaining * 86_400_000);
}
